import React, { ReactElement } from 'react';
import { Paper, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import ImageButton from '../Buttons/ImageButton';

type Props = {
  children: JSX.Element;
  onAccept: () => void;
  onReject: () => void;
};

const PromptModal = ({ children, onAccept, onReject }: Props): ReactElement => {
  const classes = useStyles();

  return (
    <Paper className={classes.box}>
      {children}
      <Box className={classes.buttonsWrapper}>
        <ImageButton imageName={'rejectButton'} onClick={onReject} />
        <ImageButton imageName={'acceptButton'} onClick={onAccept} />
      </Box>
    </Paper>
  );
};

export default PromptModal;

const useStyles = makeStyles(() => {
  return {
    box: {
      padding: `${remCalc(20)} ${remCalc(50)}`,
      background: '#fff',
      borderRadius: remCalc(20),
      margin: '0 auto',
      boxShadow: '0px 3px 6px 1px #616161',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      flexFlow: 'column',
    },
    buttonsWrapper: {
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'space-evenly',
      minWidth: remCalc(220),
      width: '100%',
    },
  };
});
